// extracted by mini-css-extract-plugin
export default {"color":"utils_color__wgewP","swatch":"utils_swatch__DbryE","popover":"utils_popover__c88QJ","cover":"utils_cover__+YYCK"};